import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useInterviewOnJobCards() {
  return useCbhFlag(CbhFeatureFlag.INTERVIEWS_ON_JOB_CARDS, {
    defaultValue: {
      enabled: false,
      cohorts: [],
    },
  });
}
